import React, { useEffect, useRef, useState } from 'react';
import { HEYFORM_BASE_URL, HEYFORM_FORM_ID } from '../config';
import Layout from '../components/Layout';

/**
 * FormPage
 *
 * Lädt das HeyForm-Embed und übergibt eine frisch generierte correlation_id
 * als URL-Parameter (→ Hidden Field in HeyForm).
 *
 * Nach dem Submit leitet HeyForm den User zur /waiting-Seite weiter.
 * Die correlation_id wird im sessionStorage gespeichert, damit /waiting
 * sie nach dem Stripe-Redirect noch kennt.
 *
 * Voraussetzung HeyForm:
 *  - Hidden Field mit Key "correlation_id" anlegen
 *  - Redirect on completion → https://deine-domain.example/waiting
 */
export default function FormPage() {
  const iframeRef = useRef(null);
  const [cid, setCid] = useState(null);

  function redirectToWaitingPage() {
    const cid = sessionStorage.getItem('correlation_id');
    window.location.href = `/waiting?cid=${cid}`;
  }

  useEffect(() => {
    let id = sessionStorage.getItem('correlation_id');
    if (!id) {
      id = crypto.randomUUID();
      sessionStorage.setItem('correlation_id', id);
    }
    
    setCid(id); // löst Re-Render aus
  }, []);

  useEffect(() => {
    const handler = (event) => {
      if (event.data?.source !== 'HEYFORM') return;
      
      if (event.data?.eventName == 'FORM_SUBMITTED') {
        redirectToWaitingPage()
      }
    };

    window.addEventListener('message', handler);
    return () => window.removeEventListener('message', handler);
  }, []);


  if(!cid) return null;

  const formUrl = `${HEYFORM_BASE_URL}/form/${HEYFORM_FORM_ID}?correlation_id=${cid}`;

  return (
    <iframe
      ref={iframeRef}
      src={formUrl}
      style={{ width: '100%', height: '100vh', border: 'none' }}
      allow="camera; microphone"
    />
  );
}
